import type { Context, Span } from '@opentelemetry/api';
import type { SpanProcessor, ReadableSpan } from '@opentelemetry/sdk-trace-base';
import { getMetricTags } from '@m43/core';

/**
 * Span processor that automatically adds session attributes (metric tags) to all spans.
 * Mirrors the SessionAttributesProcessor in cad-electron's otel-trace.ts.
 *
 * Session attributes include dynamic runtime data like department_id, user_id, etc.
 * These are read fresh on each span start since they may change at runtime
 * (e.g., after bootstrap completes and user info becomes available).
 */
export class SessionAttributesProcessor implements SpanProcessor {
    onStart(span: Span, _context: Context): void {
        const metricTags = getMetricTags();
        if (!metricTags) {
            return;
        }
        Object.entries(metricTags).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                span.setAttribute(key, value);
            }
        });
    }

    onEnd(_span: ReadableSpan): void {
        // No-op
    }

    forceFlush(): Promise<void> {
        return Promise.resolve();
    }

    shutdown(): Promise<void> {
        return Promise.resolve();
    }
}
